import { Injectable, TemplateRef } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class LayoutService {
	public screenSize: number;
	public stickyHeaderTemplates: [] = [];

	addStickyHeaderForRoute(currentUrl: string, template: TemplateRef<any>) {
		this.stickyHeaderTemplates[currentUrl] = template;
	}
}

export enum ScreenSize {
	MOBILE_S = 1,
	MOBILE_M = 2,
	MOBILE_L = 3,
	TABLET = 4,
	LAPTOP = 5,
	LAPTOP_L = 6,
}
